import { CommonModule as NgCommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { CommonBasicModule } from '@app/common/basic/common.basic.module';
import { AgGridModule } from 'ag-grid-angular';
import { TreeModule } from '@ali-hm/angular-tree-component';
import { NbGridComponent } from './components/nb-grid/nb-grid.component';
import { NbTreeviewComponent } from './components/nb-treeview/nb-treeview.component';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';

import { MatIconModule } from '@angular/material/icon';
import { NbMarkdownComponent } from './components/nb-markdown/nb-markdown.component';

@NgModule({
  imports: [
    NgCommonModule,
    FormsModule,
    AgGridModule,
    TreeModule,
    CommonBasicModule,
    MatChipsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule,
    MatIconModule,
  ],
  exports: [
    NbGridComponent,
    NbTreeviewComponent,
    MatChipsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule,
    MatIconModule,
    NbMarkdownComponent,
  ],
  declarations: [NbGridComponent, NbTreeviewComponent, NbMarkdownComponent],
  providers: [],
})
export class CommonAdvancedModule {
  static forRoot(): ModuleWithProviders<CommonAdvancedModule> {
    return {
      ngModule: CommonAdvancedModule,
    };
  }
}
